import { LockClosedIcon, ServerIcon } from '@heroicons/react/solid';
import { Link } from '@remix-run/react';
import teamAji from "~/assets/images/landing/about-us/Ajitesh.jpg";
import advisorCamille from "~/assets/images/landing/about-us/Camille.jpg";
import teamDan from "~/assets/images/landing/about-us/Dan_Ball.jpg";
import advisorDan from "~/assets/images/landing/about-us/Dan_Simpson.jpg";
import teamKanav from "~/assets/images/landing/about-us/Kanav.jpg";
import advisorKellie from "~/assets/images/landing/about-us/Kellie.jpg";
import banner from "~/assets/images/landing/about-us/a-01.jpg";
import mission from "~/assets/images/landing/about-us/a-02.jpg";
import impact from "~/assets/images/landing/about-us/a-03.jpg";
import workcation from "~/assets/images/landing/about-us/a-04.jpg";
import Footer from "~/components/LandingFooter";
import Header from "~/components/LandingHeader";


const people = [
    {
        name: 'Kellie Meek',
        role: 'Psychologist & Emergency Services',
        imageUrl: advisorKellie,
        bio: 'With over 12 years working in emergency services, Kellie brings a wealth of experience and a passion for ensuring our technology helps support the wellbeing of peer supporters.',
    },
    {
        name: 'Daniel Simpson',
        role: 'General Manager (Multiple EAPs)',
        imageUrl: advisorDan,
        bio: 'Managing two Employee assistance providers, Daniel helps advise on how we integrate with EAP services, and brings unique insights into wellbeing in the Mining and Resources sectors.',
    },
    {
        name: 'Camille Wilson',
        role: 'Lived experience and the workplace',
        imageUrl: advisorCamille,
        bio: 'Camille is a leading voice on workplace mental health and encourages organisations to involve people with lived experience in the design of mental health and peer support programs.',
    }
]

const team = [
    {
        id: 3,
        img: teamKanav,
        name: 'Kanav Jamwal',
        designation: 'The Data Stuff',
    },
    {
        id: 1,
        img: teamDan,
        name: 'Dan Ball',
        designation: 'The Business Stuff',
    },
    {
        id: 4,
        img: teamAji,
        name: 'Ajitesh Tiwari',
        designation: 'The Tech Stuff',
    },
]


const features = [
    {
        name: 'Meaningful connection in the workplace',
        description:
            'Our passion is helping people support each other, and using technology and data to help boost authentic in-person relationships, not replace them',
        icon: LockClosedIcon,
    },
    {
        name: 'Sustainable and safe support for supporters',
        description: 'To help protect the wellbeing of people who support others and boost their continued growth and personal development',
        icon: LockClosedIcon,
    },
    {
        name: 'Encourage appreciation for the underappreciated',
        description: 'Peer supporters are selfless humans, but a pat on the back goes a long way. We care about highlighting the wonderful support they give to others',
        icon: ServerIcon,
    },
]

export default function About() {
    return (
        <>
            <Header />
            {/* First Section */}
            <div className="relative bg-lcolor-50">
                <div className="mx-auto max-w-7xl lg:grid lg:grid-cols-12 lg:gap-x-8 lg:px-8">
                    <div className="px-6 pb-24 pt-10 sm:pb-32 lg:col-span-7 lg:px-0 lg:pb-48 lg:pt-36 xl:col-span-6">
                        <div className="mx-auto max-w-2xl lg:mx-0">
                            <p className="font-semibold mt-6 text-xl leading-8 text-lcolor-500">
                                We care about
                            </p>
                            <h1 className="mt-4 text-4xl font-bold tracking-tight text-lcolor-200">
                                Real connection.
                            </h1>
                            <h1 className="mt-2 text-4xl font-bold tracking-tight text-lcolor-200">
                                Reciprocal support.
                            </h1>
                            <h1 className="mt-2 text-4xl font-bold tracking-tight text-lcolor-500">
                                At work and in the community.
                            </h1>
                        </div>
                    </div>
                    <div className="relative lg:col-span-5 lg:-mr-8 xl:absolute xl:inset-0 xl:left-1/2 xl:mr-0">
                        <img
                            className="aspect-[3/2] w-full bg-gray-50 object-cover lg:absolute lg:inset-0 lg:aspect-auto lg:h-full"
                            src={banner}
                            alt=""
                        />
                    </div>
                </div>
            </div>


            {/* Second Section */}
            <div className="overflow-hidden bg-white py-24 sm:py-32">
                <div className="mx-auto max-w-7xl px-6 lg:px-8">
                    <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
                        <div className="lg:pr-8 lg:pt-4">
                            <div className="lg:max-w-lg">
                                <h2 className="text-xl font-semibold leading-7 text-lcolor-500">Why do we exist? well since you asked..</h2>
                                <p className="mt-2 text-3xl font-bold tracking-tight text-lcolor-100 sm:text-4xl">Our Mission</p>

                                <dl className="mt-10 max-w-xl space-y-8 text-xl leading-7 text-lcolor-500 lg:max-w-none">
                                    {features.map((feature) => (
                                        <div key={feature.name} className="relative">
                                            <dt className="inline font-semibold text-lcolor-500">
                                                {feature.name}
                                            </dt>
                                            <br />
                                            <dd className="inline text-lg">{feature.description}</dd>
                                        </div>
                                    ))}
                                </dl>
                            </div>
                        </div>
                        <div className="flex justify-center align-middle h-full w-full"><img
                            src={mission}
                            alt="Product screenshot"
                            className="object-cover w-[24rem] max-w-none rounded-xl shadow-xl ring-1 ring-gray-400/10 sm:w-[28rem] md:-ml-4 lg:-ml-0"
                        /></div>
                    </div>
                </div>
            </div>

            {/* Team */}
            <div className="relative bg-lcolor-50 py-32">
                <div className="max-w-md px-4 mx-auto text-center sm:max-w-3xl sm:px-6 lg:max-w-7xl lg:px-8">
                    <div>
                        <h2 className="mt-2 mb-32 text-3xl font-bold leading-10 tracking-tight text-lcolor-200 sm:text-4xl">Meet our Leadership Team</h2>
                    </div>
                    <div className="grid grid-cols-1 mt-20 gap-y-5 md:grid-cols-3 md:gap-x-12 md:gap-y-5">
                        {team.map((item) => (
                            <div key={item.id} className="relative">

                                <div className="items-center justify-center w-full mb-5 sm:shrink-0">
                                    <img src={item.img} className="mx-auto w-fit h-64 object-cover rounded-full" alt="" />
                                </div>
                                <div className="w-full px-6 py-6 rounded-lg">
                                    <p className="text-xl font-medium leading-7 text-lcolor-200 mb-2">{item.name}</p>
                                    <p className="text-lg font-medium text-lcolor-500">{item.designation}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Testimonials */}
            {/* <div className="bg-lcolor-500 py-24 sm:py-32">
                <div className="mx-auto max-w-7xl px-6 lg:px-8">
                    <h2 className="text-center text-4xl font-semibold leading-8 text-white mb-24">
                        Trusted by innovative organisations
                    </h2>
                    <div className="mx-auto grid max-w-lg grid-cols-4 items-center gap-x-8 gap-y-10 sm:max-w-xl sm:grid-cols-6 sm:gap-x-10 lg:mx-0 lg:max-w-none lg:grid-cols-5">
                        <img
                            className="col-span-2 max-h-12 w-full object-contain lg:col-span-1"
                            src="https://tailwindui.com/img/logos/158x48/transistor-logo-white.svg"
                            alt="Transistor"
                            width={158}
                            height={48}
                        />
                        <img
                            className="col-span-2 max-h-12 w-full object-contain lg:col-span-1"
                            src="https://tailwindui.com/img/logos/158x48/reform-logo-white.svg"
                            alt="Reform"
                            width={158}
                            height={48}
                        />
                        <img
                            className="col-span-2 max-h-12 w-full object-contain lg:col-span-1"
                            src="https://tailwindui.com/img/logos/158x48/tuple-logo-white.svg"
                            alt="Tuple"
                            width={158}
                            height={48}
                        />
                        <img
                            className="col-span-2 max-h-12 w-full object-contain sm:col-start-2 lg:col-span-1"
                            src="https://tailwindui.com/img/logos/158x48/savvycal-logo-white.svg"
                            alt="SavvyCal"
                            width={158}
                            height={48}
                        />
                        <img
                            className="col-span-2 col-start-2 max-h-12 w-full object-contain sm:col-start-auto lg:col-span-1"
                            src="https://tailwindui.com/img/logos/158x48/statamic-logo-white.svg"
                            alt="Statamic"
                            width={158}
                            height={48}
                        />
                    </div>
                </div>
            </div> */}

            {/* Values */}
            <div className="bg-white py-24 sm:py-32">
                <div className="mx-auto max-w-7xl px-6 lg:px-8">
                    <div className="mx-auto grid max-w-2xl grid-cols-1 items-start gap-x-8 gap-y-16 sm:gap-y-24 lg:mx-0 lg:max-w-none lg:grid-cols-2">
                        <div className="flex justify-center items-center h-full">
                            <div className="lg:pr-4">
                                <div className="relative overflow-hidden rounded-3xl bg-gray-900 px-6 pb-9 pt-64 shadow-2xl sm:px-12 lg:max-w-lg lg:px-8 lg:pb-8 xl:px-10 xl:pb-10">
                                    <img
                                        className="absolute inset-0 h-full w-full object-cover brightness-125 saturate-0"
                                        src={workcation}
                                        alt=""
                                    />
                                    <div className="absolute inset-0 bg-lcolor-200 mix-blend-multiply" />
                                    <div
                                        className="absolute left-1/2 top-1/2 -ml-16 -translate-x-1/2 -translate-y-1/2 transform-gpu blur-3xl"
                                        aria-hidden="true"
                                    >
                                        <div
                                            className="aspect-[1097/845] w-[68.5625rem] bg-gradient-to-tr from-[#000000] to-[#041F60] opacity-40"
                                            style={{
                                                clipPath:
                                                    'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                                            }}
                                        />
                                    </div>
                                    <figure className="relative isolate">
                                        <svg
                                            viewBox="0 0 162 128"
                                            fill="none"
                                            aria-hidden="true"
                                            className="absolute -left-2 -top-4 -z-10 h-32 stroke-white/20"
                                        >
                                            <path
                                                id="0ef284b8-28c2-426e-9442-8655d393522e"
                                                d="M65.5697 118.507L65.8918 118.89C68.9503 116.314 71.367 113.253 73.1386 109.71C74.9162 106.155 75.8027 102.28 75.8027 98.0919C75.8027 94.237 75.16 90.6155 73.8708 87.2314C72.5851 83.8565 70.8137 80.9533 68.553 78.5292C66.4529 76.1079 63.9476 74.2482 61.0407 72.9536C58.2795 71.4949 55.276 70.767 52.0386 70.767C48.9935 70.767 46.4686 71.1668 44.4872 71.9924L44.4799 71.9955L44.4726 71.9988C42.7101 72.7999 41.1035 73.6831 39.6544 74.6492C38.2407 75.5916 36.8279 76.455 35.4159 77.2394L35.4047 77.2457L35.3938 77.2525C34.2318 77.9787 32.6713 78.3634 30.6736 78.3634C29.0405 78.3634 27.5131 77.2868 26.1274 74.8257C24.7483 72.2185 24.0519 69.2166 24.0519 65.8071C24.0519 60.0311 25.3782 54.4081 28.0373 48.9335C30.703 43.4454 34.3114 38.345 38.8667 33.6325C43.5812 28.761 49.0045 24.5159 55.1389 20.8979C60.1667 18.0071 65.4966 15.6179 71.1291 13.7305C73.8626 12.8145 75.8027 10.2968 75.8027 7.38572C75.8027 3.6497 72.6341 0.62247 68.8814 1.1527C61.1635 2.2432 53.7398 4.41426 46.6119 7.66522C37.5369 11.6459 29.5729 17.0612 22.7236 23.9105C16.0322 30.6019 10.618 38.4859 6.47981 47.558L6.47976 47.558L6.47682 47.5647C2.4901 56.6544 0.5 66.6148 0.5 77.4391C0.5 84.2996 1.61702 90.7679 3.85425 96.8404L3.8558 96.8445C6.08991 102.749 9.12394 108.02 12.959 112.654L12.959 112.654L12.9646 112.661C16.8027 117.138 21.2829 120.739 26.4034 123.459L26.4033 123.459L26.4144 123.465C31.5505 126.033 37.0873 127.316 43.0178 127.316C47.5035 127.316 51.6783 126.595 55.5376 125.148L55.5376 125.148L55.5477 125.144C59.5516 123.542 63.0052 121.456 65.9019 118.881L65.5697 118.507Z"
                                            />
                                            <use href="#0ef284b8-28c2-426e-9442-8655d393522e" x={86} />
                                        </svg>
                                        {/* <img src="https://tailwindui.com/img/logos/workcation-logo-white.svg" alt="" className="h-12 w-auto" /> */}
                                        <blockquote className="mt-6 text-xl font-semibold leading-8 text-white">
                                            <p>
                                                “Dan was fantastic, very empathetic, and knowledgeable. He created a trusting environment where the group could openly discuss topics and was incredibly understanding and interested in everyones experiences.”
                                            </p>
                                        </blockquote>
                                        <figcaption className="mt-6 text-sm leading-6 text-gray-300">
                                            <strong className="font-semibold text-white">People & Culture Representative,</strong> Global Financial Institution
                                        </figcaption>
                                    </figure>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className="text-base leading-7 text-gray-700 lg:max-w-lg">
                                <p className="text-xl font-semibold leading-7 text-lcolor-500">The values we live by</p>
                                <h1 className="mt-2 text-3xl font-bold tracking-tight text-lcolor-100 sm:text-4xl">
                                    Making lives a little easier,
                                    <br />and a little difference earlier
                                </h1>
                                <div className="max-w-xl">
                                    <p className="mt-6 text-lcolor-500 text-lg">
                                        After working in some pretty unsupportive workplaces we have seen a lot of what not to do when 'supporting' the wellbeing of workers. Too often, organisations promote a hush culture where any sign of struggle is either swept under the carpet or dealt with reactively.
                                        <br /><br />
                                        We believe in values that create a healthy workplace culture where people can thrive and support each other.
                                    </p>
                                </div>
                            </div>
                            <div className="mt-10 text-lg lg:max-w-lg">
                                <p className="text-lcolor-500 font-bold">Our core values:</p>
                                <br />
                                <ul>
                                    <li className="text-lcolor-500"><span className="font-bold">Awareness.</span> Being mindful of each other and the support available. How we can help and what our limits are</li>
                                    <br />
                                    <li className="text-lcolor-500"><span className="font-bold">Empathy.</span> Nurturing compassion and supporting one another genuinely, without judgment</li>
                                    <br />
                                    <li className="text-lcolor-500"><span className="font-bold">Integrity.</span> Upholding honesty and ethics as the foundation of how we move forward as people and a company</li>
                                    <br />
                                    <li className="text-lcolor-500"><span className="font-bold">Connection.</span> To each other and to the world, building bonds through our collective experiences that unite us</li>
                                    <br />
                                    <li className="text-lcolor-500"><span className="font-bold">Growth.</span> Personal and professional development to continuously improve and pass on our learnings to others</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="relative bg-lcolor-50">
                <div className="mx-auto max-w-7xl lg:grid lg:grid-cols-12 lg:gap-x-8 lg:px-8">
                    <div className="pl-6 pr-6 lg:pl-0 pb-16 pt-10 sm:pb-24 lg:col-span-7 lg:pb-48 lg:pt-36 xl:col-span-6">
                        <div className="mx-auto max-w-2xl lg:mx-0">
                            <p className="mt-6 text-xl font-semibold leading-8 text-lcolor-500">
                                Our Impact
                            </p>
                            <h1 className="mt-4 text-3xl font-bold tracking-tight text-lcolor-200 sm:text-4xl">
                                50% of profits are donated
                            </h1>
                            <p className="mt-6 text-lcolor-500 text-lg">to providing mental health training to people in community and not-for-profit organisations.</p>
                            <p className="mt-3 mb-8 text-lcolor-500 text-lg">If you are a community leader or not-for-profit organisations and would like to find out more</p>
                            <Link
                                to="/contact"
                                className="rounded-md bg-lcolor-500 px-6 py-3 text-sm font-semibold text-white shadow-sm hover:bg-lcolor-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                            >
                                Contact Us
                            </Link>
                        </div>
                    </div>
                    <div className="relative lg:col-span-5 lg:-mr-8 xl:absolute xl:inset-0 xl:left-1/2 xl:mr-0">
                        <img
                            className="aspect-[3/2] w-full bg-gray-50 object-cover lg:absolute lg:inset-0 lg:aspect-auto lg:h-full"
                            src={impact}
                            alt=""
                        />
                    </div>
                </div>
            </div>

            <div className="bg-white py-24 sm:py-32">
                <div className="mx-auto max-w-7xl px-6 lg:px-8">
                    <div className="mx-auto max-w-2xl sm:text-center">
                        <h2 className="text-3xl font-bold tracking-tight text-lcolor-100 sm:text-4xl">Meet our advisors</h2>
                        <p className="mt-6 text-xl leading-8 text-lcolor-500">
                            A wonderful bunch of humans with lived experience and a heap of knowledge.
                        </p>
                    </div>
                    <ul
                        role="list"
                        className="mx-auto mt-20 grid max-w-2xl grid-cols-1 gap-x-6 gap-y-20 sm:grid-cols-2 lg:max-w-4xl lg:gap-x-8 xl:max-w-none"
                    >
                        {people.map((person) => (
                            <li key={person.name} className="flex flex-col gap-6 xl:flex-row">
                                <img className="aspect-[4/5] w-36 flex-none rounded-2xl object-cover" src={person.imageUrl} alt="" />
                                <div className="flex-auto">
                                    <h3 className="text-xl font-semibold leading-8 tracking-tight text-lcolor-500">{person.name}</h3>
                                    <p className="text-lg leading-7 text-lcolor-100">{person.role}</p>
                                    <p className="mt-6 text-lg leading-7 text-lcolor-500">{person.bio}</p>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            <div className="bg-white">
                <div className="px-6 py-24 sm:px-6 sm:py-32 lg:px-8">
                    <div className="mx-auto max-w-2xl text-center">
                        <h2 className="text-3xl font-bold tracking-tight text-lcolor-500 sm:text-4xl">
                            <p className='pb-6 lg:pb-0'>Ready to <span className="text-lcolor-200">Peer</span> a little closer?</p>
                            <p>We <span className="text-lcolor-200">Support</span> that.</p>
                        </h2>
                        <div className="mt-10 flex items-center justify-center gap-x-6">
                            <Link
                                to="/contact"
                                className="rounded-md bg-lcolor-500 px-6 py-3 text-sm font-semibold text-white shadow-sm hover:bg-lcolor-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                            >
                                Get in touch
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    )
}
